module.exports = __webpack_public_path__ + "static/img/12bg_11.051936f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/12bg_11.png
// module id = 640
// module chunks = 1